module.exports = __webpack_public_path__ + "img/swiper4.b562862f.png";